import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessagePptFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M9.33317 1.33337H3.99984C3.2665 1.33337 2.67317 1.93337 2.67317 2.66671L2.6665 13.3334C2.6665 14.0667 3.25984 14.6667 3.99317 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3334V5.33337L9.33317 1.33337ZM11.9998 13.3334H3.99984V2.66671H8.6665V6.00004H11.9998V13.3334Z" />
    <path d="M9.10239 6.89067L6.43572 11.5095C5.33152 10.718 4.99593 9.20327 5.69059 8.00007C6.38526 6.79688 7.86485 6.33014 9.10239 6.89067ZM9.57119 7.16134L8.37253 9.23749L10.4441 10.4335C10.9675 9.27617 10.6009 7.90055 9.57119 7.16134ZM8.10319 9.70399L6.90453 11.7801C8.06185 12.3036 9.43419 11.932 10.1747 10.9L8.10319 9.70399Z" />
  </Icon>
);

export default memo(QuotedMessagePptFileIcon);
